var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMediaReviewRank({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.59586 10.5773L9.59743 10.5757L11.5 8.6215V0.499999L0.5 0.5L0.5 12.5H7.74078L9.59586 10.5773Z",
    stroke: "#C7A267"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.08924 11.8636L10.8985 8.99929C10.9761 8.9202 10.9201 8.78677 10.8093 8.78677H8C7.93096 8.78677 7.875 8.84273 7.875 8.91177V11.7761C7.875 11.8881 8.01085 11.9436 8.08924 11.8636Z",
    fill: "#C7A267",
    stroke: "#C7A267",
    strokeWidth: 0.75
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6 2.94252L6.7529 4.1456L6.85986 4.3165L7.05546 4.36541L8.43231 4.70969L7.52077 5.79752L7.39128 5.95205L7.40521 6.15319L7.50325 7.56905L6.18699 7.03828L6 6.96288L5.81301 7.03828L4.49675 7.56905L4.59479 6.15319L4.60872 5.95205L4.47922 5.79752L3.56769 4.70969L4.94454 4.36541L5.14014 4.3165L5.2471 4.1456L6 2.94252Z",
    stroke: "#C7A267"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediaReviewRank);
export default __webpack_public_path__ + "static/media/MediaReviewRank.86d50b49d132da2f2b960f2a2d043dff.svg";
export { ForwardRef as ReactComponent };